module.exports = __webpack_public_path__ + "img/transporte.3417407d.svg";